import { Component, OnInit, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef, ViewChild, TemplateRef } from '@angular/core';
import { IGlobalSettings, IGlobalSettingsSaveResponse } from '@irb/irb-settings/irb-settings.model';
import { IrbSettingsService } from '@irb/irb-settings/irb-settings.service';
import { AppService } from '@irb/app.service';
import { IEvent, IrbSettingsEvents, IrbAppEvents,IrbEditorsEvents } from '@irb-common/events';
import { PageService } from '@irb-common/services/page.service';
import { Subscription, Observable, of } from 'rxjs';
import { UtilityService } from '@irb/irb-common/services/utility.service';
import { HttpErrorResponse } from '@angular/common/http';
import { SelectItem } from 'primeng/api';
import { SettingsPage } from '@irb/irb-settings/irb-settings.page';
import { IrbAuthenticationService } from '@irb/irb-authentication/irb-authentication.service';
import { IAlertDialogData } from '@irb/app.model';
import {InventoryService} from "@irb/irb-orders/order-blotter/inventory/inventory.service";
import {AnalyticsService} from "@irb-common/analytics/analytics.service";
import {DropdownFilterComponent} from "@irb-common/components/dropdown-filter/dropdown-filter.component";
import {Router} from "@angular/router";
import {EditorModelService} from "@irb/irb-editors/editor-model/editor-model.service";
import {DomSanitizer, SafeUrl} from "@angular/platform-browser";

@Component({ standalone: false,
  selector: 'irb-settings-logic',
  templateUrl: './settings-logic.component.html',
  styleUrls: ['./settings-logic.component.scss','../../irb-common/styles/dialog.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SettingsLogicComponent implements SettingsPage<IGlobalSettings>, OnInit, OnDestroy {
  @ViewChild('advisorImposedBuyMin') advisorImposedBuyMin: any;
  @ViewChild('advisorImposedBuyMinPercent') advisorImposedBuyMinPercent: any;
  @ViewChild('advisorImposedSellMin') advisorImposedSellMin: any;
  @ViewChild('advisorImposedSellMinPercent') advisorImposedSellMinPercent: any;
  @ViewChild('dontSellShortTermGainDays') dontSellShortTermGainDays: any;
  @ViewChild('includeEqAltSecPos') includeEqAltSecPos: any;
  @ViewChild('includeEqAltSecNeg') includeEqAltSecNeg: any;
  @ViewChild('revertTLHSellPos') revertTLHSellPos: any;
  @ViewChild('revertTLHSellNeg') revertTLHSellNeg: any;
  @ViewChild('dontSellPenaltyPos') dontSellPenaltyPos: any;
  @ViewChild('dontSellPenaltyNeg') dontSellPenaltyNeg: any;
  @ViewChild('preventEqtySaleCCPos') preventEqtySaleCCPos: any;
  @ViewChild('preventEqtySaleCCNeg') preventEqtySaleCCNeg: any;
  @ViewChild('ccClosePositionPos') ccClosePositionPos: any;
  @ViewChild('ccClosePositionNeg') ccClosePositionNeg: any;
  @ViewChild('taxSettingsMax') taxSettingsMax: any;
  @ViewChild('taxSettingsHigh') taxSettingsHigh: any;
  @ViewChild('taxSettingsMedium') taxSettingsMedium: any;
  @ViewChild('taxSettingsLow') taxSettingsLow: any;

  @ViewChild('tradeApplyListForBuyDollar') tradeApplyListForBuyDollar: any;
  @ViewChild('tradeApplyListForBuyPercentage') tradeApplyListForBuyPercentage: any;
  @ViewChild('tradeApplyListForSellDollar') tradeApplyListForSellDollar: any;
  @ViewChild('tradeApplyListForSellPercentage') tradeApplyListForSellPercentage: any;
  @ViewChild('tlhMinPercInput') tlhMinPercInput: any;
  @ViewChild('tlhMinDollarAmntInput') tlhMinDollarAmntInput: any;

  _globalSettings: IGlobalSettings;
  originalGlobalSettings: IGlobalSettings;
  _isModified: boolean;
  eventSubscription: Subscription;
  showUnsavedChangesWarning: boolean = false;
    tradeApplyList: Array<any>;
  defaultExpandedPanels:Array<string>=["HISTORY", "TRADE_MIN","DIRECTED_TRADE","TAX_FEES", "TLH", "WASH_SALE_SETTINGS","OPTIONS","TAX_SENSITIVITY"];
  isadmin:boolean=false;
    advisorMinBuyApplicableTo: any;
    advisorMinBuyPercentApplicableTo: any;
    advisorMinSellApplicableTo: any;
    advisorMinSellPercentApplicableTo: any;
  tlhType: string = null;
  isTlhWsaEnabled: boolean = false; 
  validationErrors: string[];
  validationErrorTemplates: TemplateRef<any>[];
  washSaleAccounts: string = null;
  washSaleAccountsDefault: string = 'Taxable Accounts Only';
  learnMoreUrl: SafeUrl;
  ENABLE_SETTINGS_HIST = false;

  constructor(
    public iss: IrbSettingsService, 
    private cdr: ChangeDetectorRef,
    private util: UtilityService,
    private as: AppService,
    private ps: PageService,
    public ias:IrbAuthenticationService,
    public ats: AnalyticsService,
    public editorModelService: EditorModelService,
    private sanitizer: DomSanitizer) {
      this.ats.trackGlobalSettingsRebalancingEvent();
      this.eventSubscription = this.as.getEvents().subscribe((s)=> {this.processEvent(s);});
      this.getLearnMoreUrl();
      this.ENABLE_SETTINGS_HIST = this.as.getItem("IRB_APP_CONFIG")?.featureFlags?.ENABLE_SETTINGS_HIST || false;

      this.tradeApplyList = [
          {
              name: 'Apply new default to new securities only',
            value: 'Apply new default to new securities only'
          },
          {
              name: 'Apply new default to all existing securities',
            value: 'Apply new default to all existing securities'
          }
      ];
    }

  ngOnInit() {
    this.ias.getAppConfigDetails().subscribe((data:any)=>{
      this.isadmin=data.isAdmin;
    });

    this.iss.getGlobalSettings().subscribe((data: any) => {
      this.load(data as IGlobalSettings);
    });

    const config = this.as.getItem("IRB_APP_CONFIG");
    if (config) {
      this.isTlhWsaEnabled = config.isTlhWsaEnabled;
    }

    if (!this.isTlhWsaEnabled) {
      this.defaultExpandedPanels = ["HISTORY", "TRADE_MIN","DIRECTED_TRADE1","TAX_FEES","OPTIONS","TAX_SENSITIVITY"];
    }
    if (!this.ENABLE_SETTINGS_HIST) {
      this.defaultExpandedPanels = this.defaultExpandedPanels.filter(p => p !== 'HISTORY');
    }

    this.ps.deserializePageState(this.as.getFromSession("pageState"),["logicGridDiv"]);
    this.iss.loadExpansionState(this.defaultExpandedPanels.length,"settings-logic",this.defaultExpandedPanels);
    if (this.ENABLE_SETTINGS_HIST) {
      this.iss.updateExpansionState('HISTORY','closed');
    }
    this.cdr.detectChanges();
  }

    setDropDown(searchStr: any, ddname: string) {
        const f = DropdownFilterComponent.getFilteredList(searchStr, this.tradeApplyList);
        if (ddname === 'tradeApplyListForBuyDollar') {
            this.tradeApplyListForBuyDollar.set(f);
        }
        if (ddname === 'tradeApplyListForBuyPercentage') {
            this.tradeApplyListForBuyPercentage.set(f);
        }
        if (ddname === 'tradeApplyListForSellDollar') {
            this.tradeApplyListForSellDollar.set(f);
        }
        if (ddname === 'tradeApplyListForSellPercentage') {
            this.tradeApplyListForSellPercentage.set(f);
        }
    }

  ngOnDestroy() {
    this.eventSubscription.unsubscribe();
  }
  
  onInputChange() {
      if (this.advisorMinBuyApplicableTo) {
          this.globalSettings.advisorMinBuyApplicableTo = this.advisorMinBuyApplicableTo.value;
      }
      if (this.advisorMinBuyPercentApplicableTo) {
          this.globalSettings.advisorMinBuyPercentApplicableTo = this.advisorMinBuyPercentApplicableTo.value;
      }
      if (this.advisorMinSellApplicableTo) {
          this.globalSettings.advisorMinSellApplicableTo = this.advisorMinSellApplicableTo.value;
      }
      if (this.advisorMinSellPercentApplicableTo) {
          this.globalSettings.advisorMinSellPercentApplicableTo = this.advisorMinSellPercentApplicableTo.value;
      }
      if (this.globalSettings?.allowWashSaleBuys) {
          if (this.washSaleAccounts == null) {this.washSaleAccounts = this.washSaleAccountsDefault}
          this.globalSettings.washSaleAccounts = this.washSaleAccounts;
      } else {
         this.globalSettings.washSaleAccounts = 'None';
         this.washSaleAccounts = null;
      }

    window.setTimeout(() => {
      this.isModified = !this.util.compare(this.originalGlobalSettings, this.globalSettings);
      this.as.fireEvent((this.isModified) ? IrbSettingsEvents.IS_MODIFIED : IrbSettingsEvents.IS_NOT_MODIFIED);
      //this.showUnsavedChangesWarning = false;
      this.cdr.detectChanges();
      this.validateInput().subscribe(_validationErrors => {});
    });
  }

  onClosePositionYes() {
    if(this.isadmin) {
      this.validatePreventEquitySale();
    }
  }
  onClosePositionNo() {
    if(this.isadmin) {
      this.onInputChange();
    }
  }

  load(data: IGlobalSettings) {
    this.globalSettings = data;
    this.editorModelService.setGlobalSettings(data);
    this.globalSettings.currentSetting = "tradeView";
    
    this.globalSettings.advisorMinBuyApplicableTo = (this.globalSettings.advisorMinBuyApplicableTo) ? this.globalSettings.advisorMinBuyApplicableTo : "Apply new default to new securities only";
    this.globalSettings.advisorMinBuyPercentApplicableTo = (this.globalSettings.advisorMinBuyPercentApplicableTo) ? this.globalSettings.advisorMinBuyPercentApplicableTo : "Apply new default to new securities only";
    this.globalSettings.advisorMinSellApplicableTo = (this.globalSettings.advisorMinSellApplicableTo) ? this.globalSettings.advisorMinSellApplicableTo : "Apply new default to new securities only";
    this.globalSettings.advisorMinSellPercentApplicableTo = (this.globalSettings.advisorMinSellPercentApplicableTo) ? this.globalSettings.advisorMinSellPercentApplicableTo : "Apply new default to new securities only";

    this.advisorMinBuyApplicableTo = (this.globalSettings.advisorMinBuyApplicableTo === this.tradeApplyList[0].value) ? this.tradeApplyList[0] : this.tradeApplyList[1];
    this.advisorMinBuyPercentApplicableTo = (this.globalSettings.advisorMinBuyPercentApplicableTo === this.tradeApplyList[0].value) ? this.tradeApplyList[0] : this.tradeApplyList[1];
    this.advisorMinSellApplicableTo = (this.globalSettings.advisorMinSellApplicableTo === this.tradeApplyList[0].value) ? this.tradeApplyList[0] : this.tradeApplyList[1];
    this.advisorMinSellPercentApplicableTo = (this.globalSettings.advisorMinSellPercentApplicableTo === this.tradeApplyList[0].value) ? this.tradeApplyList[0] : this.tradeApplyList[1];

    this.globalSettings.advisorImposedBuyMin = this.globalSettings.advisorImposedBuyMin==null?
                                                0:this.globalSettings.advisorImposedBuyMin;
    this.globalSettings.advisorImposedSellMin = this.globalSettings.advisorImposedSellMin==null?
                                                0:this.globalSettings.advisorImposedSellMin;  
    this.globalSettings.advisorImposedBuyMinPercent = this.globalSettings.advisorImposedBuyMinPercent==null?
                                                0:this.globalSettings.advisorImposedBuyMinPercent;                                                                                               
    this.globalSettings.advisorImposedSellMinPercent = this.globalSettings.advisorImposedSellMinPercent==null?
                                                0:this.globalSettings.advisorImposedSellMinPercent;
    if(data.revertHarvestSellEnabled === null){
        this.globalSettings.revertHarvestSellEnabled = false;
    }

    this.globalSettings.tlhMinPerc = typeof this.globalSettings.tlhMinPerc === 'number' ? this.globalSettings.tlhMinPerc : null;
    this.globalSettings.tlhMinDollarAmnt = typeof this.globalSettings.tlhMinDollarAmnt === 'number' ? this.globalSettings.tlhMinDollarAmnt : null;
    this.tlhType = null;
    if (this.globalSettings.isTlhLotLevel || this.globalSettings.isTlhPositionLevel)
      this.tlhType = this.globalSettings.isTlhLotLevel ? 'lot' : 'position';
    if (this.globalSettings.washSaleAccounts !=='None') {
      this.washSaleAccounts = this.globalSettings.washSaleAccounts;
    }
    this.originalGlobalSettings = this.util.clone(this.globalSettings);
    this.isModified = false;
    this.as.fireEvent(IrbSettingsEvents.IS_NOT_MODIFIED);
    this.cdr.detectChanges();
  }  

  processEvent(event: IEvent) {
    switch(event.type) {
      case IrbSettingsEvents.SAVE: 
        this.save();
        break;
      case IrbSettingsEvents.UNSAVED_CHANGES:
        if(this.isModified) {
          this.showUnsavedChangesWarning = true;
          this.cdr.detectChanges();
        }
        break;
      case IrbSettingsEvents.REVERT_CHANGES:
        this.revert();
        break;
    }
  }  

  revert() {
    if(this.isModified) {
      this.load(this.originalGlobalSettings);
    }
  }

  save() {
    this.validateInput().subscribe(validationErrors => {
      if(validationErrors.length === 0) {
        this.as.fireEvent(IrbSettingsEvents.SAVE_START);

        this.iss.saveRebalancingGlobalSettings(this.globalSettings).subscribe((data: any) => {
          const response = data as IGlobalSettingsSaveResponse;

          if(response.responseStatus === "SUCCESS") {
              this.iss.getGlobalSettings().subscribe((data: any) => {
                this.as.fireEvent(IrbSettingsEvents.SAVE_SUCCESS, "Rebalancing settings were updated.");
                this.load(data as IGlobalSettings);
                this.as.fireEvent(IrbAppEvents.GRID_REFRESH);
              });              
          } else {
            this.as.fireEvent(IrbSettingsEvents.SAVE_ERROR);
          }
        },() => {
          this.as.fireEvent(IrbSettingsEvents.SAVE_ERROR);
        });
      } else {
        this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
            severity: 'error',
            summary: 'Save',
            detail: "Please correct invalid entries before saving."
        });
      }
    });
  }  
  
  validateInput(): Observable<string[]> {
    this.validationErrors = [];
    this.validationErrorTemplates = [];

    if(this.advisorImposedBuyMin && this.isadmin && !this.advisorImposedBuyMin?.inputControl.valid) {
      this.validationErrors.push('');
    }

    if(this.advisorImposedBuyMinPercent && this.isadmin && !this.advisorImposedBuyMinPercent?.inputControl.valid) {
      this.validationErrors.push('');
    }

    if(this.advisorImposedSellMin && this.isadmin && !this.advisorImposedSellMin?.inputControl.valid) {
      this.validationErrors.push('');
    }

    if(this.advisorImposedSellMinPercent && this.isadmin && !this.advisorImposedSellMinPercent?.inputControl.valid) {
      this.validationErrors.push('');
    }

    if(this.dontSellShortTermGainDays && this.isadmin && !this.dontSellShortTermGainDays?.inputControl.valid) {
      this.validationErrors.push('');
    }

    if (this.globalSettings.isTlhLotLevel || this.globalSettings.isTlhPositionLevel) {
      if (this.tlhMinPercInput && !this.tlhMinPercInput?.inputControl.valid)
        this.validationErrors.push('');

      if (this.tlhMinDollarAmntInput && !this.tlhMinDollarAmntInput?.inputControl.valid)
        this.validationErrors.push('');
    }

    if (this.tlhMinPercInput && this.tlhMinPercInput?.inputControl.valid && this.globalSettings.tlhMinPerc !== null) {
      if (!this.globalSettings.isTlhLotLevel && !this.globalSettings.isTlhPositionLevel) {
        this.validationErrors.push('');
      }
    }

    if (this.tlhMinDollarAmntInput && this.tlhMinDollarAmntInput?.inputControl.valid && this.globalSettings.tlhMinDollarAmnt !== null) {
      if (!this.globalSettings.isTlhLotLevel && !this.globalSettings.isTlhPositionLevel) {
        this.validationErrors.push('');
      }
    }

    return of(this.validationErrors);
  }

  validatePreventEquitySale() {
    if(this.globalSettings.ccPreventEquitySale === true) {
      this.as.fireEvent(IrbAppEvents.SHOW_ALERT, {
        msg: "You have selected to have iRebal close corresponding covered call positions when selling equities. Your selection to have iRebal prevent the sale of equities with covered calls has been set to No.",
        dType: "WARN",
        onProceed: (() => {
          setTimeout(() => {
            this.globalSettings.ccPreventEquitySale = false;
            this.globalSettings.ccClosePosition = true;
            this.onInputChange();
          })
        }).bind(this)
      } as IAlertDialogData);
    } else {
      this.onInputChange();
    }    
  }

  validateMFRules() {
    if(this.globalSettings.isMfSellAmtTypeDollars === true) {
      this.as.fireEvent(IrbAppEvents.SHOW_ALERT, {
        msg: "You have selected to have iRebal avoid redemption penalties. To do this, iRebal must calculate mutual fund orders in shares. Your default selection for Mutual Fund sells has been set to Shares. You can individually edit orders on the blotter to have sells sent in dollars.",
        dType: "WARN",
        onProceed: (() => {
          setTimeout(() => {
            this.globalSettings.isMfSellAmtTypeDollars = false;
            this.globalSettings.avoidRedemptionPenalty = true;
            this.onInputChange();
          })
        }).bind(this)
      } as IAlertDialogData);
    } else {
      this.onInputChange();
    }    
  }  

  get globalSettings() {
    return this._globalSettings;
  }

  set globalSettings(newGlobalSettings: IGlobalSettings) {
    this._globalSettings = newGlobalSettings;
  }

  get isModified() {
    return this._isModified;
  }

  set isModified(newIsModified: boolean) {
    this._isModified = newIsModified;
  }

  goToSecurities() {
    this.as.fireEvent(IrbSettingsEvents.NAVIGATE, {url: "/models/security-master"});
  }

  onTLHTypeChange(tlhType: string) {
    if (tlhType === 'lot') {
      this.globalSettings.isTlhLotLevel = true;
      this.globalSettings.isTlhPositionLevel = false;
    } else {
      this.globalSettings.isTlhLotLevel = false;
      this.globalSettings.isTlhPositionLevel = true;
    }
    this.onInputChange();

    if (this.globalSettings.tlhMinPerc === null) {
      this.tlhMinPercInput.inputField.nativeElement.focus();
      this.tlhMinPercInput.inputField.nativeElement.blur();
      this.tlhMinPercInput.inputControl.setValue('');
    }
    if (this.globalSettings.tlhMinDollarAmnt === null) {
      this.tlhMinDollarAmntInput.inputField.nativeElement.focus();
      this.tlhMinDollarAmntInput.inputField.nativeElement.blur();
      this.tlhMinDollarAmntInput.inputControl.setValue('');
    }
  }
  onClickWashSaleHowTo() {
        const passData: any = {
            rebalanceTypeObject: {},
            isTLHSetInGlobal: false
        }
        this.as.fireEvent(IrbSettingsEvents.SHOW_WASH_SALE_INFO, passData);
  }

  getLearnMoreUrl() {
    let url = 'https://' + 'sac.schwabinstitutional.com';
    url += '/si2/published/ask/resource/irebal-tlh-full-rebalance';
    this.learnMoreUrl = this.sanitizer.bypassSecurityTrustUrl(url);
  }
}
